<template lang='pug'>
  script(type='application/ld+json' v-text='navigationSchema')
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'topLevelCategories'
    ]),
    navigationSchema () {
      const navElements = []

      this.topLevelCategories.forEach(category => {
        navElements.push(this.generateMarkup(category.attributes.label, `categories/${category.attributes['slug-url']}`))
      })

      navElements.unshift(this.generateMarkup(this.$t('products.productGroup.newArrivals'), 'new-arrivals'))
      navElements.push(this.generateMarkup(this.$t('products.brand.title'), 'brands'))

      if (!vueSupport.header.hideSales) {
        navElements.push(this.generateMarkup(this.$t('products.landingPage.sale'), 'sale'))
      }

      return navElements
    }
  },

  methods: {
    generateMarkup (elementName, elementSlug) {
      return {
        '@context': 'http://schema.org/',
        '@type': 'siteNavigationElement',
        'name': elementName,
        'url': window.config.domain + elementSlug
      }
    }
  }
}
</script>
